import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Search, Calendar, MapPin, ArrowRight, Trophy, Users, Plane, ChevronRight, Mail, CheckCircle2, Sparkles, Filter, Zap, TrendingUp, Clock } from 'lucide-react';
export function Home() {
  return <div className="w-full" data-id="element-1113">
      {/* Hero Section - Two Column Layout */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-900 via-[#0E578E] to-gray-900" data-id="element-1114">
        {/* Animated Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-1115">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl animate-pulse" data-id="element-1116"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-1117"></div>
        </div>

        {/* Diagonal Lines Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-1118"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12 sm:py-20 relative z-10 w-full" data-id="element-1119">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-1120">
            {/* Left Column - Text Content */}
            <div className="text-center lg:text-left" data-id="element-1121">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-4 sm:mb-6 leading-none tracking-tight" data-id="element-1122">
                Run
                <span className="block bg-gradient-to-r from-[#01AAE7] via-cyan-400 to-[#01AAE7] bg-clip-text text-transparent mt-2" data-id="element-1123">
                  Anywhere
                </span>
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-white/80 font-light leading-relaxed mb-6 sm:mb-8" data-id="element-1124">
                Discover and register for races across the globe. From local 5Ks
                to destination marathons.
              </p>

              {/* Additional Info */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-6 text-white/70" data-id="element-1125">
                <div className="flex items-center gap-2" data-id="element-1126">
                  <div className="w-2 h-2 bg-[#01AAE7] rounded-full" data-id="element-1127"></div>
                  <span className="text-xs sm:text-sm font-medium" data-id="element-1128">
                    10,000+ Events
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1129">
                  <div className="w-2 h-2 bg-[#01AAE7] rounded-full" data-id="element-1130"></div>
                  <span className="text-xs sm:text-sm font-medium" data-id="element-1131">
                    180 Countries
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1132">
                  <div className="w-2 h-2 bg-[#01AAE7] rounded-full" data-id="element-1133"></div>
                  <span className="text-xs sm:text-sm font-medium" data-id="element-1134">
                    Trusted by 500K+ Runners
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column - Redesigned Filter Card */}
            <div data-id="element-1135">
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-1136">
                {/* Header Section */}
                <div className="bg-gradient-to-r from-[#01AAE7] to-[#0199d6] px-6 sm:px-8 py-5 sm:py-6" data-id="element-1137">
                  <h3 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-1138">
                    Find Your Race
                  </h3>
                  <p className="text-white/90 text-xs sm:text-sm" data-id="element-1139">
                    Search thousands of events worldwide
                  </p>
                </div>

                {/* Form Section */}
                <div className="p-6 sm:p-8" data-id="element-1140">
                  {/* Unified Search Bar */}
                  <div className="relative mb-6" data-id="element-1141">
                    <input type="text" placeholder="Event name or keyword..." className="w-full px-4 sm:px-5 py-3 sm:py-4 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all placeholder:text-gray-400 text-sm sm:text-base" data-id="element-1142" />
                    <Search className="absolute right-4 sm:right-5 top-1/2 -translate-y-1/2 h-4 sm:h-5 w-4 sm:w-5 text-gray-400" data-id="element-1143" />
                  </div>

                  {/* Filter Grid - Compact Design */}
                  <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-1144">
                    {/* Location */}
                    <div className="relative" data-id="element-1145">
                      <MapPin className="absolute left-3 top-3.5 h-4 w-4 text-[#01AAE7] z-10" data-id="element-1146" />
                      <select className="w-full pl-9 sm:pl-10 pr-3 py-3 sm:py-3.5 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-700 text-xs sm:text-sm font-medium transition-all appearance-none cursor-pointer" data-id="element-1147">
                        <option data-id="element-1148">Location</option>
                        <option data-id="element-1149">United States</option>
                        <option data-id="element-1150">United Kingdom</option>
                        <option data-id="element-1151">Canada</option>
                        <option data-id="element-1152">Australia</option>
                      </select>
                      <ChevronRight className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none rotate-90" data-id="element-1153" />
                    </div>

                    {/* Date */}
                    <div className="relative" data-id="element-1154">
                      <Calendar className="absolute left-3 top-3.5 h-4 w-4 text-[#01AAE7] z-10" data-id="element-1155" />
                      <select className="w-full pl-9 sm:pl-10 pr-3 py-3 sm:py-3.5 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-700 text-xs sm:text-sm font-medium transition-all appearance-none cursor-pointer" data-id="element-1156">
                        <option data-id="element-1157">Date</option>
                        <option data-id="element-1158">This Week</option>
                        <option data-id="element-1159">This Month</option>
                        <option data-id="element-1160">Next 3 Months</option>
                        <option data-id="element-1161">Next 6 Months</option>
                      </select>
                      <ChevronRight className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none rotate-90" data-id="element-1162" />
                    </div>

                    {/* Distance - Full Width */}
                    <div className="relative col-span-2" data-id="element-1163">
                      <Trophy className="absolute left-3 top-3.5 h-4 w-4 text-[#01AAE7] z-10" data-id="element-1164" />
                      <select className="w-full pl-9 sm:pl-10 pr-3 py-3 sm:py-3.5 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] text-gray-700 text-xs sm:text-sm font-medium transition-all appearance-none cursor-pointer" data-id="element-1165">
                        <option data-id="element-1166">All Distances</option>
                        <option data-id="element-1167">5K</option>
                        <option data-id="element-1168">10K</option>
                        <option data-id="element-1169">Half Marathon</option>
                        <option data-id="element-1170">Marathon</option>
                        <option data-id="element-1171">Ultra Marathon</option>
                      </select>
                      <ChevronRight className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none rotate-90" data-id="element-1172" />
                    </div>
                  </div>

                  {/* Search Button */}
                  <button className="group w-full px-6 py-3 sm:py-4 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 relative overflow-hidden mb-4 text-sm sm:text-base" data-id="element-1173">
                    <span className="relative z-10" data-id="element-1174">Search Races</span>
                    <ArrowRight className="h-4 sm:h-5 w-4 sm:w-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1175" />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-1176"></div>
                  </button>

                  {/* Quick Links */}
                  <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm" data-id="element-1177">
                    <button className="text-gray-600 hover:text-[#01AAE7] font-medium transition-colors flex items-center gap-1" data-id="element-1178">
                      <Filter className="h-3 sm:h-3.5 w-3 sm:w-3.5" data-id="element-1179" />
                      More Filters
                    </button>
                    <span className="text-gray-300" data-id="element-1180">•</span>
                    <button className="text-gray-600 hover:text-[#01AAE7] font-medium transition-colors" data-id="element-1181">
                      Popular Races
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Events Section with Ad */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white" data-id="element-1182">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1183">
          <div className="mb-8 sm:mb-12 text-center" data-id="element-1184">
            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-1185">
              Featured Events
            </h2>

            {/* Description */}
            <p className="text-lg sm:text-xl text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-1186">
              Discover the most popular races trending this week across the
              country and around the world
            </p>
          </div>

          {/* Main Layout: Full width on mobile, 80/20 split on desktop */}
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-1187">
            {/* Events Cards - Full width on mobile, 80% on desktop */}
            <div className="w-full lg:flex-[0_0_calc(80%-1rem)]" data-id="element-1188">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-1189">
                {[{
                id: 2,
                title: 'City Run Challenge 2024',
                date: 'March 15, 2024',
                location: 'San Francisco, CA',
                image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=800&h=600&fit=crop&auto=format&q=80'
              }, {
                id: 3,
                title: 'Coastal Half Marathon',
                date: 'March 22, 2024',
                location: 'San Diego, CA',
                image: 'https://images.unsplash.com/photo-1532444458054-01a7dd3e9fca?w=800&h=600&fit=crop&auto=format&q=80'
              }, {
                id: 4,
                title: 'Mountain Trail Ultra',
                date: 'April 5, 2024',
                location: 'Denver, CO',
                image: 'https://images.unsplash.com/photo-1571008887538-b36bb32f4571?w=800&h=600&fit=crop&auto=format&q=80'
              }].map(event => <div key={event.id} className="group relative rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#01AAE7] transition-all duration-300 flex flex-col" style={{
                backgroundColor: '#FCFCFD'
              }} data-id="element-1190">
                    {/* Image with Gradient Overlay */}
                    <div className="h-48 sm:h-56 relative overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-1191">
                      <img src={event.image} alt={event.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" loading="lazy" data-id="element-1192" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1193"></div>

                      {/* Floating Badge */}
                      <div className="absolute top-3 sm:top-4 right-3 sm:right-4" data-id="element-1194">
                        <div className="bg-white/95 backdrop-blur-sm px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full shadow-lg" data-id="element-1195">
                          <span className="text-xs font-bold text-[#0E578E]" data-id="element-1196">
                            Featured
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-5 sm:p-6 flex-grow flex flex-col" data-id="element-1197">
                      {/* Date Badge */}
                      <div className="flex items-center gap-2 mb-3 sm:mb-4" data-id="element-1198">
                        <div className="flex items-center gap-1.5 sm:gap-2 bg-blue-50 text-[#01AAE7] px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-lg" data-id="element-1199">
                          <Calendar className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-1200" />
                          <span className="text-xs sm:text-sm font-bold" data-id="element-1201">
                            {event.date}
                          </span>
                        </div>
                      </div>

                      {/* Title */}
                      <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0E578E] transition-colors leading-tight" data-id="element-1202">
                        {event.title}
                      </h3>

                      {/* Location */}
                      <div className="flex items-center gap-2 text-gray-600 mb-4 sm:mb-6 flex-grow" data-id="element-1203">
                        <MapPin className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-400 flex-shrink-0" data-id="element-1204" />
                        <span className="text-xs sm:text-sm font-medium" data-id="element-1205">
                          {event.location}
                        </span>
                      </div>

                      {/* Button */}
                      <Link to={`/events/${event.id}`} className="w-full text-white bg-gradient-to-r from-[#01AAE7] to-[#0199d6] rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 py-3 sm:py-3.5 px-4 font-bold text-sm sm:text-base mt-auto text-center" data-id="element-1206">
                        View Event
                      </Link>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Ad Section - Hidden on mobile, 20% on desktop */}
            <div className="hidden lg:block lg:flex-[0_0_calc(20%-1rem)]" data-id="element-1207">
              <div className="sticky top-8" data-id="element-1208">
                <div className="relative rounded-xl overflow-hidden shadow-lg h-[424px] group cursor-pointer" data-id="element-1209">
                  <img src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=424&fit=crop&auto=format&q=80" alt="Running gear advertisement" className="w-full h-full object-cover" data-id="element-1210" />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70" data-id="element-1211"></div>
                  <div className="absolute inset-0 flex flex-col justify-between p-6 text-white" data-id="element-1212">
                    <div data-id="element-1213">
                      <div className="bg-[#01AAE7] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4" data-id="element-1214">
                        SPONSORED
                      </div>
                      <h3 className="text-2xl font-bold mb-2 leading-tight" data-id="element-1215">
                        Premium Running Gear
                      </h3>
                      <p className="text-sm text-white/90 mb-4" data-id="element-1216">
                        Elevate your performance with cutting-edge technology
                      </p>
                    </div>
                    <div data-id="element-1217">
                      <div className="mb-4" data-id="element-1218">
                        <p className="text-3xl font-bold mb-1" data-id="element-1219">30% OFF</p>
                        <p className="text-sm text-white/80" data-id="element-1220">
                          Limited Time Offer
                        </p>
                      </div>
                      <button className="w-full bg-white text-[#0E578E] font-bold py-3 px-4 rounded-lg hover:bg-gray-100 transition-colors shadow-lg" data-id="element-1221">
                        Shop Now
                      </button>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-[#01AAE7]/0 group-hover:bg-[#01AAE7]/10 transition-colors duration-300" data-id="element-1222"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Travel Deals Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-[#0E578E] to-[#083556] relative overflow-hidden" data-id="element-1223">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-1224">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl" data-id="element-1225"></div>
          <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1226"></div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10" data-id="element-1227">
          <div className="text-center" data-id="element-1228">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl mb-4 border border-white/20" data-id="element-1229">
              <Plane className="h-8 w-8 text-white" data-id="element-1230" />
            </div>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight" data-id="element-1231">
              Exclusive Travel Deals
            </h2>

            {/* Description */}
            <p className="text-lg sm:text-xl text-white/90 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-1232">
              Access special discounts on flights, hotels, and race packages for
              destinations worldwide
            </p>

            {/* Benefits List */}
            <div className="grid sm:grid-cols-3 gap-4 mb-8 max-w-3xl mx-auto" data-id="element-1233">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1234">
                <div className="text-2xl font-black text-white mb-1" data-id="element-1235">
                  Up to 30%
                </div>
                <div className="text-xs text-white/80 font-semibold" data-id="element-1236">
                  Off Travel Packages
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1237">
                <div className="text-2xl font-black text-white mb-1" data-id="element-1238">500+</div>
                <div className="text-xs text-white/80 font-semibold" data-id="element-1239">
                  Race Destinations
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1240">
                <div className="text-2xl font-black text-white mb-1" data-id="element-1241">24/7</div>
                <div className="text-xs text-white/80 font-semibold" data-id="element-1242">
                  Booking Support
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center" data-id="element-1243">
              <Link to="/create-account" className="group inline-flex items-center gap-2 px-8 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base" data-id="element-1244">
                <span data-id="element-1245">Create Free Account</span>
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1246" />
              </Link>

              <Link to="/sign-in" className="group inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold rounded-xl hover:bg-white/20 transition-all text-base" data-id="element-1247">
                <span data-id="element-1248">Sign In to View Deals</span>
              </Link>
            </div>

            {/* Note */}
            <p className="text-white/70 text-sm mt-4" data-id="element-1249">
              Travel deals are exclusively available to registered members
            </p>
          </div>
        </div>
      </section>

      {/* Clubs Section */}
      <section className="py-12 sm:py-16 lg:py-24 bg-gray-50" data-id="element-1250">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1251">
          <div className="mb-8 sm:mb-12 text-center" data-id="element-1252">
            <h2 className="text-3xl sm:text-4xl lg:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-1253">
              Running Clubs Near You
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-1254">
              Connect with local running communities and find your perfect
              training group
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-1255">
            {[{
            id: 1,
            name: 'City Striders',
            location: 'Boston, MA',
            description: 'A community of urban runners focused on road racing and weekly group runs through the city.',
            image: 'https://images.unsplash.com/photo-1571008887538-b36bb32f4571?w=800&h=500&fit=crop&auto=format&q=80'
          }, {
            id: 2,
            name: 'Mountain Goats',
            location: 'Boulder, CO',
            description: "Trail running enthusiasts exploring Colorado's best mountain paths and challenging terrain.",
            image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&h=500&fit=crop&auto=format&q=80'
          }, {
            id: 3,
            name: 'Urban Runners',
            location: 'New York, NY',
            description: 'Social running club bringing together runners of all levels for fun and fitness in the city.',
            image: 'https://images.unsplash.com/photo-1483721310020-03333e577078?w=800&h=500&fit=crop&auto=format&q=80'
          }].map(club => <div key={club.id} className="group relative rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#01AAE7] transition-all duration-300" style={{
            backgroundColor: '#FCFCFD'
          }} data-id="element-1256">
                <div className="h-40 sm:h-48 relative overflow-hidden bg-gray-200" data-id="element-1257">
                  <img src={club.image} alt={club.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-1258" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1259"></div>
                </div>

                <div className="p-5 sm:p-6" data-id="element-1260">
                  <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0E578E] transition-colors leading-tight" data-id="element-1261">
                    {club.name}
                  </h3>

                  <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 line-clamp-2 leading-relaxed" data-id="element-1262">
                    {club.description}
                  </p>

                  <div className="flex items-center gap-2 text-gray-600 mb-4 sm:mb-6" data-id="element-1263">
                    <MapPin className="h-3.5 sm:h-4 w-3.5 sm:w-4 text-gray-400 flex-shrink-0" data-id="element-1264" />
                    <span className="text-xs sm:text-sm font-medium" data-id="element-1265">
                      {club.location}
                    </span>
                  </div>

                  <button className="w-full text-white bg-gradient-to-r from-[#01AAE7] to-[#0199d6] rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 py-3 sm:py-3.5 px-4 font-bold text-sm sm:text-base" data-id="element-1266">
                    View Club
                  </button>
                </div>
              </div>)}
          </div>

          {/* View All Clubs Button */}
          <div className="mt-12 sm:mt-16 text-center" data-id="element-1267">
            <Link to="/clubs" className="group inline-flex items-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden text-base sm:text-lg" data-id="element-1268">
              <span className="relative z-10" data-id="element-1269">View All Clubs</span>
              <ArrowRight className="h-4 sm:h-5 w-4 sm:w-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1270" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-1271"></div>
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-[#0E578E] to-[#083556] relative overflow-hidden" data-id="element-1272">
        {/* Decorative Elements */}
        <div className="absolute inset-0 opacity-10" data-id="element-1273">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl" data-id="element-1274"></div>
          <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1275"></div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10" data-id="element-1276">
          <div className="text-center" data-id="element-1277">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl mb-4 border border-white/20" data-id="element-1278">
              <Mail className="h-8 w-8 text-white" data-id="element-1279" />
            </div>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight" data-id="element-1280">
              Never Miss a Beat
            </h2>

            {/* Description */}
            <p className="text-lg sm:text-xl text-white/90 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-1281">
              Get race alerts, training tips, and exclusive deals delivered to
              your inbox every week
            </p>

            {/* Form */}
            <form className="max-w-md mx-auto space-y-3" data-id="element-1282">
              <input type="email" placeholder="Enter your email address" className="w-full px-4 sm:px-5 py-3 sm:py-4 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white focus:bg-white text-gray-900 text-sm sm:text-base transition-all placeholder:text-gray-500" data-id="element-1283" />

              <button type="submit" className="group w-full inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base" data-id="element-1284">
                <span data-id="element-1285">Subscribe Now</span>
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1286" />
              </button>
            </form>

            {/* Note */}
            <p className="text-white/70 text-sm mt-4" data-id="element-1287">
              We respect your privacy. Unsubscribe anytime with one click.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Section */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white" data-id="element-1288">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1289">
          <div className="mb-8 sm:mb-12 text-center" data-id="element-1290">
            <h2 className="text-3xl sm:text-4xl lg:text-4xl font-black text-gray-900 mb-4 leading-tight" data-id="element-1291">
              Our Blog Posts
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-1292">
              Expert advice, training tips, and inspiration to help you reach
              your running goals
            </p>
          </div>

          {/* Main Layout: Full width on mobile, 80/20 split on desktop */}
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-1293">
            {/* Blog Cards - Full width on mobile, 80% on desktop */}
            <div className="w-full lg:flex-[0_0_calc(80%-1rem)]" data-id="element-1294">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-1295">
                {[{
                id: 1,
                title: '10 Tips for Your First Marathon',
                category: 'Training',
                date: 'Mar 10, 2024',
                image: 'https://images.unsplash.com/photo-1513593771513-7b58b6c4af38?auto=format&fit=crop&q=80&w=800&h=600',
                excerpt: 'Preparing for 26.2 miles requires dedication and strategy.'
              }, {
                id: 2,
                title: 'Best Running Shoes of 2024',
                category: 'Gear',
                date: 'Mar 05, 2024',
                image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&q=80&w=800&h=600',
                excerpt: 'We tested the top 50 running shoes to help you find the perfect pair.'
              }, {
                id: 3,
                title: 'Nutrition Guide for Runners',
                category: 'Health',
                date: 'Feb 28, 2024',
                image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80&w=800&h=600',
                excerpt: 'What to eat before, during, and after your run to maximize performance.'
              }].map(post => <div key={post.id} className="group relative rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-[#01AAE7] transition-all duration-300 flex flex-col h-full" style={{
                backgroundColor: '#FCFCFD'
              }} data-id="element-1296">
                    <div className="h-40 sm:h-48 relative overflow-hidden bg-gray-200 flex-shrink-0" data-id="element-1297">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-1298" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1299"></div>
                    </div>

                    <div className="p-5 sm:p-6 flex flex-col flex-grow" data-id="element-1300">
                      <div className="flex items-center gap-2 mb-3 sm:mb-4" data-id="element-1301">
                        <div className="flex items-center gap-1.5 sm:gap-2 bg-blue-50 text-[#01AAE7] px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-lg" data-id="element-1302">
                          <Calendar className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-1303" />
                          <span className="text-xs sm:text-sm font-bold" data-id="element-1304">
                            {post.date}
                          </span>
                        </div>
                      </div>

                      <h3 className="text-lg sm:text-xl font-black text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0E578E] transition-colors leading-tight" data-id="element-1305">
                        {post.title}
                      </h3>

                      <p className="text-gray-600 text-xs sm:text-sm mb-4 sm:mb-6 line-clamp-2 leading-relaxed flex-grow" data-id="element-1306">
                        {post.excerpt}
                      </p>

                      <button className="w-full text-white bg-gradient-to-r from-[#01AAE7] to-[#0199d6] rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 py-3 sm:py-3.5 px-4 font-bold text-sm sm:text-base mt-auto" data-id="element-1307">
                        Read Article
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Ad Section - Hidden on mobile, 20% on desktop */}
            <div className="hidden lg:block lg:flex-[0_0_calc(20%-1rem)]" data-id="element-1308">
              <div className="sticky top-8 h-full" data-id="element-1309">
                <div className="relative rounded-xl overflow-hidden shadow-lg group cursor-pointer flex flex-col" style={{
                height: 'calc(100% - 2rem)'
              }} data-id="element-1310">
                  <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=500&fit=crop&auto=format&q=80" alt="Nutrition guide advertisement" className="w-full h-full object-cover absolute inset-0" data-id="element-1311" />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70" data-id="element-1312"></div>
                  <div className="absolute inset-0 flex flex-col justify-between p-6 text-white" data-id="element-1313">
                    <div data-id="element-1314">
                      <div className="bg-[#01AAE7] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4" data-id="element-1315">
                        SPONSORED
                      </div>
                      <h3 className="text-2xl font-bold mb-2 leading-tight" data-id="element-1316">
                        Nutrition Coaching
                      </h3>
                      <p className="text-sm text-white/90 mb-4" data-id="element-1317">
                        Personalized meal plans designed for peak performance
                      </p>
                    </div>
                    <div data-id="element-1318">
                      <div className="mb-4" data-id="element-1319">
                        <p className="text-3xl font-bold mb-1" data-id="element-1320">Free Trial</p>
                        <p className="text-sm text-white/80" data-id="element-1321">7 Days Access</p>
                      </div>
                      <button className="w-full bg-white text-[#0E578E] font-bold py-3 px-4 rounded-lg hover:bg-gray-100 transition-colors shadow-lg" data-id="element-1322">
                        Start Now
                      </button>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-[#01AAE7]/0 group-hover:bg-[#01AAE7]/10 transition-colors duration-300" data-id="element-1323"></div>
                </div>
              </div>
            </div>
          </div>

          {/* View All Posts Button */}
          <div className="mt-12 sm:mt-16 text-center" data-id="element-1324">
            <Link to="/blog" className="group inline-flex items-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden text-base sm:text-lg" data-id="element-1325">
              <span className="relative z-10" data-id="element-1326">View All Posts</span>
              <ArrowRight className="h-4 sm:h-5 w-4 sm:w-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1327" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-1328"></div>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section - Ready to Start Your Journey */}
      <section className="relative py-24 sm:py-32 overflow-hidden" data-id="element-1329">
        {/* Gradient background with texture */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-[#0E578E] to-gray-900" data-id="element-1330"></div>

        {/* Animated orbs */}
        <div className="absolute inset-0 opacity-20" data-id="element-1331">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl animate-pulse" data-id="element-1332"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-1333"></div>
        </div>

        {/* Diagonal pattern overlay */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-1334"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10" data-id="element-1335">
          {/* Title and Description - Centered at Top */}
          <div className="text-center mb-16" data-id="element-1336">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-1337">
              Ready to Start Your Journey?
            </h2>
            <p className="text-xl sm:text-2xl text-white/85 leading-relaxed max-w-3xl mx-auto" data-id="element-1338">
              Join 500,000+ runners tracking races, connecting with clubs, and
              achieving their goals.
            </p>
          </div>

          {/* Single Merged White Box */}
          <div className="bg-white rounded-3xl p-10 sm:p-12 shadow-2xl max-w-6xl mx-auto" data-id="element-1339">
            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-1340">
              {/* Left: What You Get - Centered and Larger */}
              <div className="flex flex-col justify-center" data-id="element-1341">
                <h3 className="text-3xl font-black text-gray-900 mb-8 text-center lg:text-left" data-id="element-1342">
                  What You Get
                </h3>
                <ul className="space-y-6" data-id="element-1343">
                  <li className="flex items-start gap-4" data-id="element-1344">
                    <div className="w-7 h-7 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1345">
                      <CheckCircle2 className="h-5 w-5 text-white" data-id="element-1346" />
                    </div>
                    <div data-id="element-1347">
                      <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1348">
                        Track Unlimited Races
                      </div>
                      <div className="text-base text-gray-600" data-id="element-1349">
                        Monitor your progress and PRs
                      </div>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-1350">
                    <div className="w-7 h-7 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1351">
                      <CheckCircle2 className="h-5 w-5 text-white" data-id="element-1352" />
                    </div>
                    <div data-id="element-1353">
                      <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1354">
                        Join Running Clubs
                      </div>
                      <div className="text-base text-gray-600" data-id="element-1355">
                        Connect with local communities
                      </div>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-1356">
                    <div className="w-7 h-7 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-1357">
                      <CheckCircle2 className="h-5 w-5 text-white" data-id="element-1358" />
                    </div>
                    <div data-id="element-1359">
                      <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1360">
                        Exclusive Travel Deals
                      </div>
                      <div className="text-base text-gray-600" data-id="element-1361">
                        Save on race destinations
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Right: CTA */}
              <div data-id="element-1362">
                {/* Pricing Badge */}
                <div className="bg-gradient-to-r from-[#01AAE7]/10 to-[#0E578E]/10 rounded-xl p-6 mb-6 border-2 border-[#01AAE7]/20" data-id="element-1363">
                  <div className="text-center" data-id="element-1364">
                    <div className="text-5xl font-black text-gray-900 mb-2" data-id="element-1365">
                      Free
                    </div>
                    <div className="text-sm text-gray-600 font-semibold" data-id="element-1366">
                      Forever • No credit card required
                    </div>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="space-y-3 mb-6" data-id="element-1367">
                  <Link to="/create-account" className="group w-full inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-lg" data-id="element-1368">
                    <span data-id="element-1369">Create Free Account</span>
                    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1370" />
                  </Link>

                  <Link to="/events" className="w-full inline-flex items-center justify-center gap-2 px-8 py-3 bg-gray-100 border-2 border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-200 hover:border-gray-300 transition-all text-base" data-id="element-1371">
                    <span data-id="element-1372">Browse Events First</span>
                  </Link>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-3" data-id="element-1373">
                  <div className="text-center bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1374">
                    <div className="text-2xl font-black text-gray-900 mb-1" data-id="element-1375">
                      500K+
                    </div>
                    <div className="text-xs text-gray-600 font-semibold uppercase tracking-wider" data-id="element-1376">
                      Runners
                    </div>
                  </div>
                  <div className="text-center bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1377">
                    <div className="text-2xl font-black text-gray-900 mb-1" data-id="element-1378">
                      10K+
                    </div>
                    <div className="text-xs text-gray-600 font-semibold uppercase tracking-wider" data-id="element-1379">
                      Events
                    </div>
                  </div>
                  <div className="text-center bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1380">
                    <div className="text-2xl font-black text-gray-900 mb-1" data-id="element-1381">
                      180
                    </div>
                    <div className="text-xs text-gray-600 font-semibold uppercase tracking-wider" data-id="element-1382">
                      Countries
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}